import { useRef } from 'react';
import { useService } from '@xstate/react';
import debug from 'debug';
import { machineWatcher } from '../machineDebug';
const dbg = debug('fsm:input');
export function useInput(service, debug) {
  const serviceRef = useRef(null);
  if (serviceRef.current === null) {
    serviceRef.current = service;
    if (debug) {
      machineWatcher(serviceRef.current, 'inputGroup ' + service.id, dbg);
    }
  }
  const [state, send] = useService(service);
  const {
    name,
    value,
    errorMessage
  } = state.context;
  return {
    name: name,
    value: value,
    touched: state.matches('touched.touched'),
    dirty: state.matches('pristine.dirty'),
    errorMessage: errorMessage,
    send: send
  };
}